import React from 'react';

import { Link } from 'gatsby';

import * as style from './Pagination.module.css';

const GatsbyPagination = ({ totalPages, bgColor, currentPage }) => {
  return (
    <div>
      <ul className={style.pageNumbers}>
        {totalPages.map((number, index) => (
          <Link key={index} to={number === 1 ? `/blog/` : `/blog/${number}`}>
            <li
              key={number}
              className={number === currentPage ? style.currentPage : ''}
            >
              <p
                className={`subTitle ${style.numberBox}`}
                role="presentation"
                style={{ boxShadow: `1px 500px 1px ${bgColor} inset` }}
              >
                {number}
              </p>
            </li>
          </Link>
        ))}
      </ul>
    </div>
  );
};

export default GatsbyPagination;
